import Telephone from '../interfaces/Telephone';
import { UpdateInsuredInformation } from '../interfaces/Insured';
import { checkEmail, checkIsDefined, isValidDate } from '../utils/validations';

export const InternationalPhonePrefixes: { [key: string]: Telephone } = {
  NL: '+31',
  BE: '+32',
  DE: '+49',
};

interface ParsedPhone {
  phonePrefix: Telephone;
  phoneNumberBody: string;
}

export const parsePhoneNumber = (phoneNumber = ''): ParsedPhone => {
  if (phoneNumber.includes(InternationalPhonePrefixes.NL)) {
    return {
      phonePrefix: InternationalPhonePrefixes.NL,
      phoneNumberBody: phoneNumber.split(InternationalPhonePrefixes.NL)[1],
    };
  }
  if (phoneNumber.includes(InternationalPhonePrefixes.BE)) {
    return {
      phonePrefix: InternationalPhonePrefixes.BE,
      phoneNumberBody: phoneNumber.split(InternationalPhonePrefixes.BE)[1],
    };
  }
  if (phoneNumber.includes(InternationalPhonePrefixes.DE)) {
    return {
      phonePrefix: InternationalPhonePrefixes.DE,
      phoneNumberBody: phoneNumber.split(InternationalPhonePrefixes.DE)[1],
    };
  }
  return {
    phonePrefix: InternationalPhonePrefixes.NL,
    phoneNumberBody: '',
  };
};

export const validUpdateInsuredInfoFields =  (
  values: Partial<UpdateInsuredInformation>,
): null | UpdateInsuredInformation => {
  let errors = false;
  let email = '';
  let initials = '';
  let middleName = '';
  let surname = '';
  let firstName = '';
  let dateOfBirth = '';

  if (checkIsDefined(values.email) && checkEmail(values.email)) {
    email = values.email;
  } else {
    errors = true;
  }
  if (checkIsDefined(values.initials || values.firstName)) {
    initials = values.initials || '';
    firstName = values.firstName || '';
  } else {
    errors = true;
  }
  if (checkIsDefined(values.middleName)) {
    middleName = values.middleName;
  }
  if (checkIsDefined(values.surname)) {
    surname = values.surname;
  } else {
    errors = true;
  }
  // eslint-disable-next-line
  if (checkIsDefined(values.dateOfBirth) && isValidDate(values.dateOfBirth)) {
    // eslint-disable-next-line
    dateOfBirth = values.dateOfBirth;
  } else {
    errors = true;
  }

  if (!errors) {
    return {
      email,
      gender: values.gender,
      initials,
      middleName,
      surname,
      firstName,
      dateOfBirth,
    };
  }

  return null;
};
